import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { AccountPhoneProps } from "./types";

export class AccountPhoneDefinitions extends CmsReactComponent<AccountPhoneProps> {
    static defaultProps = {};

    static schemaName = "account-phone";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Başlık",
    },
    {
        name: "description",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Açıklama",
    },];
}
